module.exports = __webpack_public_path__ + "img/Blossom Stayz Logo.4e45105c.webp";